import {
  PROOF_OF_ADDRESS_CONFIG,
  type ProofOfAddressContext,
  type ProofOfAddressData,
  type ProofOfAddressExtraction,
} from "@asap/shared/document/document-types/proof-of-address";
import { ProofOfAddressSchemas } from "@asap/shared/schemas/document/document-types/proof-of-address";
import { DocumentTypeHandler } from "../handler";

export const ProofOfAddressHandler = new DocumentTypeHandler<
  ProofOfAddressExtraction,
  ProofOfAddressData,
  ProofOfAddressContext
>({
  documentType: PROOF_OF_ADDRESS_CONFIG.documentType,
  documentName: PROOF_OF_ADDRESS_CONFIG.documentName,

  maxFiles: PROOF_OF_ADDRESS_CONFIG.maxFiles,
  acceptedMimeTypes: PROOF_OF_ADDRESS_CONFIG.acceptedMimeTypes,
  requiredFields: PROOF_OF_ADDRESS_CONFIG.requiredFields,

  endpoints: {
    extract: "documents/proof-of-address/extract",
    warn: "documents/proof-of-address/warn",
    verify: "documents/proof-of-address/verify",
    store: "documents/proof-of-address/store",
  },

  schemas: {
    extractResponse: ProofOfAddressSchemas.extractResponse,
    warnResponse: ProofOfAddressSchemas.warnResponse,
    validateResponse: ProofOfAddressSchemas.validateResponse,
    storeResponse: ProofOfAddressSchemas.storeResponse,
  },

  toastMessages: {
    success: "Le justificatif de domicile a bien été validé.",
  },

  formFields: [
    {
      key: "is_proof_of_hosting",
      label: "Le document est-il une attestation d'hébergement ?",
      type: "radio",
      options: [
        { value: "true", label: "Oui" },
        { value: "false", label: "Non" },
      ],
      colSpan: 2,
    },
    {
      key: "issue_date",
      label: PROOF_OF_ADDRESS_CONFIG.fieldLabels.issue_date,
      type: "date",
      colSpan: 1,
    },
    {
      key: "formatted_address",
      label: PROOF_OF_ADDRESS_CONFIG.fieldLabels.formatted_address,
      type: "address",
      placeholder: "Rechercher une adresse",
      colSpan: 2,
    },
  ],

  transformExtraction: (extraction: ProofOfAddressExtraction): Partial<ProofOfAddressData> => {
    if (!extraction.isValidDocumentType) {
      throw new Error(
        "Le fichier ajouté ne semble pas correspondre à un justificatif de domicile. Vérifie que ce soit bien le cas."
      );
    }

    const hasAnyExtractedField = extraction.issue_date || extraction.document_holder_name || extraction.raw_address;

    if (!hasAnyExtractedField) {
      throw new Error("Le document n'a pas pu être lu. Merci de fournir un justificatif de domicile lisible.");
    }

    const result: Partial<ProofOfAddressData> = {};

    if (extraction.issue_date) result.issue_date = extraction.issue_date;
    if (extraction.raw_address) result.formatted_address = extraction.raw_address;
    // Pre-fill the radio from OCR when detected; leave unselected (recruiter decides) when null.
    if (extraction.is_proof_of_hosting !== null) result.is_proof_of_hosting = extraction.is_proof_of_hosting;

    return result;
  },
});
